import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-visitor',
  templateUrl: './visitor.component.html',
  styleUrls: ['./visitor.component.css']
})
export class VisitorComponent implements OnInit {
    public selectedBgVisited: string = 'IN';

    public personName: string = '';

    public itemsListPersons: Item[] = [];

    public itemsListCheckOuts: Item[] = [];

    public searchingFromBtn = false;

    public personNameButtons: FormButton[] = [
        { id: 'erase', type: 'danger', icon: 'fa fa-solid fa-eraser', onClick: () => this.clear('personName') },
        { id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.searchItems() }
    ];

    constructor(private datatask: DataTaskService) {

    }

    private async loadFindPersons() {
        const list = await this.datatask.Post(117, {
            pers_name: this.personName,
            inout: this.selectedBgVisited
        });

        this.searchingFromBtn = false;
        this.itemsListPersons = list;
    }

    private async loadCheckOuts() {
        this.itemsListCheckOuts = await this.datatask.Post(120, { inout: this.selectedBgVisited });
    }

    private clear(id: string) {
        switch (id) {
            case 'personName':
                this.personName = '';
                this.itemsListPersons = [];
                break;
            default:
                break;
        }
    }

    public searchItems() {
        if (this.selectedBgVisited === 'IN') {
            if (this.personName.length > 3) this.loadFindPersons();
        }
    }

    public searchBtn() {
        if (this.selectedBgVisited === 'IN') {
            if (this.personName.length > 3) {
                this.searchingFromBtn = true;
                this.loadFindPersons();
            }
        }
    }

    public onTabChangeVisited() {
        if (this.selectedBgVisited === 'OUT') this.loadCheckOuts();
    }

    public onChanged(_: string, id: string) {
        switch (id) {
            case 'personName':
                if (this.selectedBgVisited === 'IN') {
                    if (this.personName === '') {
                        this.itemsListPersons = [];
                    }
                }
                break;
            default:
                break;
        }
    }

    private async init() {
        if (this.selectedBgVisited === 'IN') {
            if (this.personName.length > 3) this.loadFindPersons();
        }

        if (this.selectedBgVisited === 'OUT') this.loadCheckOuts();
    }

    ngOnInit() {
        this.init();
    }
}
